import { render, staticRenderFns } from "./LostMuch.vue?vue&type=template&id=8d407fd6&"
import script from "./LostMuch.vue?vue&type=script&lang=js&"
export * from "./LostMuch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports